/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { CustomerSubscriptionData_CustomerFragmentDoc } from '../../../customers/__generated__/CustomersGridItem.graphql';
export type CustomersTableCustomerFragment = { __typename: 'Customer', id: string, name: string, displayCount: number, waveSubscriptionUsage?: number | null, users: Array<{ __typename: 'User', id: string }>, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, notification?: { __typename: 'NotificationSettingsModel', id: string, status: Types.NotificationStatus, customerId: string } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null };

export const CustomersTableCustomerFragmentDoc = gql`
    fragment CustomersTableCustomer on Customer {
  id
  name
  users {
    id
  }
  waveSubscription {
    id
  }
  ...CustomerSubscriptionData_customer
  notification {
    id
    status
    customerId
  }
}
    ${CustomerSubscriptionData_CustomerFragmentDoc}`;